import {ConfigService, ErrorsService, ModelsList, StoreService, Driver} from 'shared';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class DriverService extends StoreService<Driver> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Driver);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Driver>> {
    return this.http.get<ModelsList<Driver>>(this.config.apiVerUrl('/app/drivers'), {params: queryParams});
  }

  protected insert(values: Driver): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/drivers'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/drivers/${id}`));
  }

  protected update(id, values): Observable<Driver> {
    return this.http.put<Driver>(this.config.apiVerUrl(`/app/drivers/${id}`), values);
  }

}
